import firebase from 'firebase';

import { firebaseDev } from '../constants';

firebase.initializeApp(firebaseDev);

/* cloud firestore */
const firestore = firebase.firestore();
firestore.settings({ timestampsInSnapshots: true });

/* realtime database */
const database = firebase.firestore();

export { firebase, firestore, database };



// WEBPACK FOOTER //
// ./src/utils/Firebase.js